<template>
  <div class="joinus">
    <Headers></Headers>
    <div class="joinus-center">
      <img :src="bgUrl" />
      <div class="center-body">
        <h3>为什么选择音乐窝</h3>
        <!-- <div class="list-show"></div> -->
        <div class="body-join">
          <ul>
            <li>
              <h5>普及音乐，多一种沟通方式</h5>
              <p>
                音乐窝致力于打造完整的音乐教育产业生态圈，自主研发课程教材体系，积极提供在线音乐教育及琴行/音乐新门店事业合作服务，努力成为全国影响力居首的连锁音乐玩创品牌。
              </p>
            </li>
            <li>
              <h5>重视教育，用专业打造人才</h5>
              <p>
                音乐窝注重每一位同事的自我驱动及职业发展，在富有挑战和影响力的工作下，提供完善的职业培训和晋升体系，引领你与公司一同成长，发现更多可能。
              </p>
            </li>
            <li>
              <h5>高效管理，实现工作效率最大化</h5>
              <p>
                在音乐窝，你的能力会被重视，在高效的管理下与伙伴一同并肩成长，发挥潜力，实现工作效率最大化。
              </p>
            </li>
            <li>
              <h5>细致关怀，让工作与生活融洽无间</h5>
              <p>
                每一位同事的付出都会被真诚对待，音乐窝提供舒适的办公环境，完善的社会福利和极具竞争力的薪酬激励体系，让你的工作与生活融洽无间。
              </p>
            </li>
          </ul>
          <div class="join-eml">
            <p>简历投递：hr@musicwow.com</p>
            <p>
              投递格式：请以“应聘职位＋姓名”作为邮件标题，并以附件形式附上简历
            </p>
          </div>
        </div>
        <div class="body-nav">
          <ul>
            <li @click="selected(0)" :class="{ active: active == 0 }">全部</li>
            <li
              v-for="(item, index) in navData"
              :key="index"
              :class="{ active: active == item.id }"
              @click="selected(item.id)"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div class="body-list">
          <ul>
            <li class="list-navs">
              <div>职业</div>
              <div>工作地</div>
              <div>月薪范围</div>
            </li>
            <li
              v-for="(item, index) in listData.list"
              :key="index"
              @click="onListDataBut(item.id)"
            >
              <div>{{ item.name }}</div>
              <div>{{ item.address }}</div>
              <div>{{ item.salary_range }}</div>
            </li>
          </ul>
          <div class="list-pages">
            <el-pagination
              small
              @prev-click="listDataPrevClick"
              @next-click="listDataNextClick"
              @current-change="handlePageChange"
              layout="prev, pager, next"
              :page-size="1"
              :current-page="pageSum"
              :total="listPage"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "joinus",
  data() {
    return {
      active: 0, //保存招聘type
      navData: [], //保存招聘title
      listData: [], //保存招聘类型内容
      listPage: 1,
      pageSum: 1, //当前页
      dataUrl: "", //保存跳转路劲
      bgUrl: "",
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
  },
  methods: {
    /**
     * 选择招聘类型
     */
    async selected(id) {
      this.active = id;
      this.pageSum = 1;
      let jobListData = await this.$API.getJobListData({
        type_id: this.active,
      });
      this.listPage = jobListData.data.page_sum;
      this.listData = jobListData.data;
      this.dataUrl = jobListData.url;
    },
    /**
     * 上一页
     */
    async listDataPrevClick() {
      let pageSum = this.pageSum * 1 - 1;
      let jobListData = await this.$API.getJobListData({
        type_id: this.active,
        page: pageSum,
      });
      this.listData = jobListData.data;
      this.pageSum = jobListData.data.page_current * 1;
    },
    /**
     * 下一页
     */
    async listDataNextClick() {
      let pageSum = this.pageSum * 1 + 1;
      let jobListData = await this.$API.getJobListData({
        type_id: this.active,
        page: pageSum,
      });
      this.listData = jobListData.data;
      this.pageSum = jobListData.data.page_current * 1;
    },
    async handlePageChange(v) {
      let jobListData = await this.$API.getJobListData({
        type_id: this.active,
        page: v,
      });
      this.listData = jobListData.data;
      this.pageSum = jobListData.data.page_current * 1;
    },
    /**
     * 跳转到招聘详情
     */
    onListDataBut(id) {
      localStorage.jobId = id;

      this.$router.push({ name: "JoinPage", params: { id: id } });
    },
    async onBulist() {
      let bgData = await this.$API.getBgListData({});
      let listData = bgData.data;
      // console.log(listData)
      listData.forEach((item, index) => {
        switch (item.type) {
          case "mobile_joinus":
            this.bgUrl = item.image;
            // console.log(this.bgUrl)
            break;
        }
      });
    },
  },
  mounted() {},
  async created() {
    this.onBulist();
    let newsListData = await this.$API.getJobTypeData({});
    this.navData = newsListData.data;
    this.active = 0;
    let jobListData = await this.$API.getJobListData({
      type_id: this.active,
    });
    this.listData = jobListData.data;
    // console.log(this.listData)
    this.listPage = jobListData.data.page_sum;
    this.pageSum = jobListData.data.page_current * 1;
    this.dataUrl = jobListData.url;
  },
};
</script>
<style lang="sass" scoped>
.joinus
  .joinus-center
    padding-top: 60px
    img
      width: 100%
    .center-body
      margin: 20px
      h3
        font-size: 18px
        text-align: left
        margin-bottom: 20px
        font-weight: 600

      .list-show
        width: 44px
        height: 5px
        background: #07D1AA
        margin: 20px auto
      .body-join
        text-align: left
        ul
          li
            padding: 10px 0

            h5
              font-size: 14px
              font-weight: 600
              margin-bottom: 10px
            p
              font-size: 12px
              color: rgba(0,0,0,0.5)
        .join-eml
          padding-top: 20px
          color: rgba(0,0,0,0.3)
          font-size: 12px
          line-height: 20px

      .body-nav
        margin-top: 20px
        overflow-x: auto
        white-space: nowrap
        ul
          li
            width: 60px
            height: 30px
            display: inline-block
            margin: auto
            font-size: 14px
            line-height: 30px
            color: rgba(0,0,0,0.5)
          .active
            color: #07D1AA
            border-bottom: 1px solid #07D1AA
      .body-nav::-webkit-scrollbar
        display: none
      .body-list
        ul
          .list-navs
            margin: 10px 0
          li
            display: flex
            color: rgba(0,0,0,0.5)
            line-height: 30px
            font-size: 12px
            div:nth-child(1)
              flex: 4
            div:nth-child(2)
              flex: 6
            div:nth-child(3)
              flex: 4
            div
              margin: auto

              // /padding: 30px 0
        .list-pages
          padding: 30px 0
</style>

